import { __rest } from "tslib";
import * as React from 'react';
const ExchangeContext = React.createContext(null);
export function useExchange() {
    return React.useContext(ExchangeContext);
}
const ExchangeProvider = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return React.createElement(ExchangeContext.Provider, { value: props }, children);
};
export default ExchangeProvider;
